import {createWebHistory, createRouter} from "vue-router";
import NotFound from '../components/NotFound.vue'
import Login from '../components/auth/Login.vue'
import Logout from "../components/auth/Logout.vue";
import Domain from '../views/Domain.vue'
import TemplateEditor from "../views/TemplateEditor.vue";
import CustomFields from "../views/CustomFields";


const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
  },
  {
    path: "/domain",
    name: "Domain",
    component: Domain,
    props: (route) => ({query: route.query.q}),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/template/:id",
    name: "TemplateEditor",
    component: TemplateEditor,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/domain/custom-fields",
    name: "CustomFields",
    component: CustomFields,
    props: (route) => ({query: route.query.q}),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    redirect: {name: 'Domain'}
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {
    let token = getCookie('ws-token')

    if (token) {
      next()
      return
    }
    next('/login')

  } else {
    next()
  }


})

export default router;
